"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PH = void 0;
exports.PH = {
    belongsToEU: false,
    belongsToEurope: false,
    subdivisions: {
        'PH-00': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-01': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-ILN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-ILS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-LUN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-PAN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-02': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-BTN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-CAG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-ISA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-NUV': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-QUI': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-03': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-AUR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-BAN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-BUL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-NUE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-PAM': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-TAR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-ZMB': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-05': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-ALB': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-CAN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-CAS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-CAT': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-MAS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-SOR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-06': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-AKL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-ANT': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-CAP': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-GUI': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-ILI': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-NEC': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-07': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-BOH': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-CEB': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-NER': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-SIG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-08': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-BIL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-EAS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-LEY': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-NSA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-SLE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-WSA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-09': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-BAS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-ZAN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-ZAS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-ZSI': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-10': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-BUK': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-CAM': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-MSC': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-MSR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-11': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-COM': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-DAO': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-DAS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-DAV': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-DVO': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-SAR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-SCO': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-12': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-LAN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-NCO': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-SUK': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-13': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-AGN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-AGS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-DIN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-SUN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-SUR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-14': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-LAS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-MAG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-SLU': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-TAW': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-15': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-ABR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-APA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-BEN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-IFU': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-KAL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-MOU': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-40': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-BTG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-CAV': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-LAG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-QUE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-RIZ': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-41': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-MAD': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-MDC': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-MDR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-PLW': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'PH-ROM': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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